"use client";

import { c as _c } from "react/compiler-runtime";
import { ToggleButtonGroup, ToggleButtonGroupItem } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useCurrencySwitch } from "@/hooks/use-currency-switch";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
export function PageFooterCurrencyToggle() {
  const $ = _c(16);
  const {
    currency,
    setCurrency
  } = useCurrencySwitch();
  const [playSelect] = usePlaySound(Sound.Select);
  const t = useTranslations("PageFooterCurrencyToggle");
  let t0;
  if ($[0] !== playSelect || $[1] !== setCurrency) {
    t0 = value => {
      setCurrency(value);
      playSelect();
    };
    $[0] = playSelect;
    $[1] = setCurrency;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t) {
    t1 = t("crypto");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ToggleButtonGroupItem value="crypto">{t1}</ToggleButtonGroupItem>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("usd");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <ToggleButtonGroupItem value="usd">{t3}</ToggleButtonGroupItem>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== currency || $[12] !== t0 || $[13] !== t2 || $[14] !== t4) {
    t5 = <ToggleButtonGroup onValueChange={t0} size="sm" value={currency}>{t2}{t4}</ToggleButtonGroup>;
    $[11] = currency;
    $[12] = t0;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}